// extracted by mini-css-extract-plugin
export default {"alert":"aVMwENO3UZ"};